// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  bffApiUrl: 'https://api.dev.simpexo.com/customerWebapp',
  // bffApiUrl: "http://localhost:8004/customerwebappdev",
  firebase: {
    apiKey: 'AIzaSyAWOx2t4ljtaUiFIOW_BIlgjLwCXbOFeh8',
    authDomain: 'simpayx.firebaseapp.com',
    databaseURL: 'https://simpayx.firebaseio.com',
    projectId: 'simpayx',
    storageBucket: 'simpayx.appspot.com',
    messagingSenderId: '263999792826',
    appId: '1:263999792826:web:cf202ca8daeda397d1c483',
    measurementId: 'G-HMRZD6S0X0',
  },
  ORDER_COLLECTION: 'Orders',
  // ORDER_COLLECTION: "DummyOrders",
  BUSINESS_COLLECTION: 'Businesses',
  TIMEZONE: 'America/Denver',
  // CURRENCY: "$",
  // INDIAN_CURRENCY: "INR",
  // INDIAN_CURRENCY_SYMBOL: "₹",
  SECRET_KEY: '112aF13G',
  COOKIE_KEY: 'lBGWhjq6zSimPayX8YgQ1HZf0wipNVn4',
  ORDER_READY_ACTION_TIME: 30,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
